import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                                        <span
                                                            className="green font_span"><strong>Consolidate</strong></span>
                                            <ul className="greenbullet-list botm-pad-zero space-pad"
                                                style={{paddingTop: '9px'}}>
                                                <li>Was everyone happy with your decision?</li>
                                                <li>Did it have the correct/intended outcome?</li>
                                                <li>Is there anybody you need to discuss your decision
                                                    with?
                                                </li>
                                            </ul>
                                            <p>By using this guide, you should be able to formulate some
                                                effective and ethical decisions. You
                                                may want to practise by designing a hypothetical situation
                                                first and trying to come up with an
                                                ethical solution using this guide.</p>
                                            <p>Following a guide such as this one is also a way of reducing
                                                ‘risk’. If a clear plan is not followed,
                                                an action which may appear to be ethical may not be
                                                correctly implemented. Research has
                                                indicated this is a likely cause for many high-profile
                                                unethical decisions in large businesses.<a
                                                    className="superscripttext supLinesapce"
                                                    href="further_info.php?course=300"><sup>3</sup></a></p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>BAD CHOICE DETECTORS
                                            </div>
                                            <p>If you are still undecided about the ethical course of
                                                action, keep some of the following questions
                                                on hand as ethical ‘smoke detectors’. If alarm bells start
                                                ringing in your head once the question is
                                                asked, then it is likely that you are not proceeding down
                                                the most ethical path. It is, perhaps, a
                                                good time to revisit the PK guide to ethical decisions on
                                                previous page.</p>
                                            <div align="center"><img
                                                src={require('@images/ethical-decision2.png')}
                                                alt="image"/></div>
                                            <br/>
                                            <div className="border_subtitle">Integrity</div>
                                            <p>Think about how important it is to show integrity in your
                                                work. Whilst sometimes it may be
                                                tempting to cut corners it is this ethical dilemma that
                                                you should consider – in the long run what
                                                is the right thing to do…</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}